import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/pro-light-svg-icons";

export default ({variant = "info"}) => (  
    <FontAwesomeIcon icon={faSpinner} className="fa-pulse fa-fw" />
);
